import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'

import { ArrowRoundedDown } from '@aok/icon-functional'
import { SecondaryButton, ErrorView } from '@aok/ui-elements'

import TeaserList from '../TeaserList/TeaserList'
import MacroContainer from '../../_layout/Macro/MacroContainer'
import { APIContext } from '../../../context/APIContext'

import { getEnvironment } from '../../../utils/appUtils'
import { fetchTeaserList } from '../../../utils/requests/handleTeaserListRequest'
import { PageType } from '../../../utils/defaultTypes'
import { GENERAL_ERROR_VIEW_PROPS } from '../../../utils/StaticTextsUtils'
import { settingsPropTypes } from '../../../utils/commonPropTypes'

const StructureList = ({ headline, initialElements, settings }) => {
  const { limit, count, tags, type } = settings

  const apiContext = useContext(APIContext)
  const [api] = useState({
    teaserListUrl: apiContext[getEnvironment('TEASER_LIST_URL') || ''],
  })

  const [errorOccurred, setErrorOccurred] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [currentElements, setCurrentElements] = useState(initialElements)
  const [currentOffset, setCurrentOffset] = useState(0)
  const moreTeasersLoadable = currentElements.length < count - 1
  const showMoreCount = count - currentElements.length < limit ? count - currentElements.length : limit

  const loadNextResults = () => {
    const newOffset = limit + currentOffset

    setIsLoading(true)
    setErrorOccurred(false)

    fetchTeaserList(
      api.teaserListUrl,
      {
        type,
        tags,
        offset: newOffset,
        limit,
      },
      (newElements) => {
        setCurrentElements([...currentElements, ...newElements])
        setCurrentOffset(newOffset)
      },
      () => {
        setErrorOccurred(true)
      },
      () => {
        setIsLoading(false)
      }
    )
  }

  return (
    <MacroContainer>
      <p className="text-20 leading-28 font-semibold font-buenos-aires">{headline}</p>

      <TeaserList context={PageType.CATEGORY} elements={currentElements} className="mt-32" />

      {/* Load more link */}
      {moreTeasersLoadable && !errorOccurred ? (
        <div className="mt-48 1280:mt-80">
          <p className="text-16 leading-24 text-6d767c text-center">{`1-${currentElements.length} von ${count} angezeigt`}</p>

          <SecondaryButton className="mt-24 mx-auto" onClick={loadNextResults} isLoading={isLoading}>
            <span>{`${showMoreCount} Weitere${showMoreCount === 1 ? 'n' : ''} anzeigen`}</span>
            {<ArrowRoundedDown className="fill-current h-16 w-16 ml-8" />}
          </SecondaryButton>
        </div>
      ) : // Error view if API error occurred
      errorOccurred ? (
        <ErrorView {...GENERAL_ERROR_VIEW_PROPS} className="mt-48 1280:mt-80" buttonClassName="self-center" />
      ) : null}
    </MacroContainer>
  )
}

StructureList.propTypes = {
  initialElements: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      releaseDate: PropTypes.string,
      abstract: PropTypes.string,
      url: PropTypes.string,
      image: PropTypes.shape({
        alt: PropTypes.string,
        variants: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
            breakpoints: PropTypes.number,
          })
        ),
      }),
    })
  ),
  settings: PropTypes.shape(settingsPropTypes),
}

StructureList.defaultProps = {
  initialElements: [],
  settings: {},
}

export default StructureList
